import Sortable from 'sortablejs'

export const SortableListHook: {
  el?: HTMLElement
  sortable?: Sortable
  mounted: () => void
  destroyed: () => void
} = {
  mounted() {
    if (!this.el) {
      return
    }

    const hook = this as any

    this.sortable = Sortable.create(this.el, {
      handle: '.drag-handle',
      animation: 150,
      onEnd() {
        if (!hook.el) {
          return
        }

        const items = hook.el.querySelectorAll('[data-route-id]')
        const orderedIds: number[] = []

        items.forEach((item: Element) => {
          const id = item.getAttribute('data-route-id')
          if (id) {
            orderedIds.push(parseInt(id, 10))
          }
        })

        hook.pushEvent('reorder', { user_route_ids: orderedIds })
      },
    })
  },

  destroyed() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
}
